import React, {FunctionComponent} from 'react';
import {Page} from 'b302-frontend-library';
import {useQuery} from '@tanstack/react-query';

import {useContinentIndexQueryConfig} from '../../../query/Continent/Query';
import CountriesContent from './CountriesContent';

const Countries: FunctionComponent = () => {
    const [continentConfig] = useContinentIndexQueryConfig();
    const continentQuery = useQuery(continentConfig);

    return (
        <Page className={'admin-countries-page'}>
            { (continentQuery.data) &&
                <CountriesContent continents={continentQuery.data} />
            }
        </Page>
    );
};

export default Countries;
